const _observedModals = new WeakSet();

function initSKContactForms() {
  document.querySelectorAll('form').forEach((form) => {
    if (!form.querySelector('[data-sk-ajax-form]')) return;
    if (form.dataset.skAjaxInit) return;
    form.dataset.skAjaxInit = '1';

    // Optional client-side validator (quote-form pattern). Only activates when
    // the form opts in via [data-sk-validate]; existing forms without the marker
    // continue to rely on Shopify's server-side validation.
    const validateContainer = form.querySelector('[data-sk-validate]');
    if (validateContainer && typeof window.SKFormValidator !== 'undefined') {
      window.SKFormValidator.init(validateContainer);
    }

    // Shopify calls form.submit() after captcha challenge completes — intercept it here
    // to do AJAX instead of a full-page navigation.
    form.submit = function () {
      submitContactForm(form);
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      // Do NOT stopImmediatePropagation: Shopify's captcha handler must fire to execute
      // the hCaptcha challenge and add the response token before we POST.

      // Client-side validation gate — abort submission if validator says invalid.
      if (validateContainer && typeof window.SKFormValidator !== 'undefined') {
        if (!window.SKFormValidator.validateForm(validateContainer)) {
          event.stopImmediatePropagation();
          return;
        }
      }

      // Invisible hCaptcha is always hidden in the DOM (offsetParent === null) even
      // when fully active, so visibility cannot be used to detect it. Presence of
      // the .h-captcha element is the reliable signal that Shopify's captcha handler
      // is attached and will call form.submit() after the challenge. Only submit
      // directly when no captcha widget exists at all.
      if (!form.querySelector('.h-captcha')) {
        submitContactForm(form);
      }
    });

    const parentModal = form.closest('.modal[data-parent], .drawer[data-parent]');
    if (parentModal && !_observedModals.has(parentModal)) {
      _observedModals.add(parentModal);
      new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.attributeName === 'class' && !parentModal.classList.contains('is-open')) {
            form.reset();
            const errorsEl = form.querySelector('.sk-contact-form__errors');
            if (errorsEl) errorsEl.hidden = true;
          }
        }
      }).observe(parentModal, { attributes: true, attributeFilter: ['class'] });
    }
  });
}

async function submitContactForm(form) {
  if (form.dataset.skAjaxSubmitting) return;
  form.dataset.skAjaxSubmitting = '1';

  const submitBtn = form.querySelector('[type="submit"]');
  const errorsEl  = form.querySelector('.sk-contact-form__errors');
  const successEl = form.querySelector('.sk-contact-form__success');
  const bodyEl    = form.querySelector('.sk-contact-form__body');

  const errorFallback = form.querySelector('[data-sk-ajax-form]')?.dataset.errorFallback
    || 'Something went wrong. Please try again.';

  errorsEl.hidden = true;
  errorsEl.querySelector('p').textContent = '';
  submitBtn.disabled = true;

  try {
    const response = await fetch(form.action, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form),
    });

    const data = await response.json().catch(() => null);

    // Treat HTTP 2xx as success; only reject when Shopify explicitly returns an error
    // status in the JSON body (422). data may be null if Shopify returns HTML after redirect.
    if (response.ok && (data?.status == null || data.status === 200)) {
      if (window.SKAnalytics?.generateLead) {
        const subject = form.querySelector('input[name="contact[subject]"]')?.value;
        window.SKAnalytics.generateLead({ lead_source: subject, form_id: form.id });
      }

      form.reset();
      submitBtn.disabled = false;

      const parentModal = form.closest('.modal.is-open');
      if (parentModal) {
        Woolman.ModalsAndDrawers.closeModalOrDrawer(parentModal.id);
      }

      if (window.SK?.showConfirmationModal) {
        const i18n = window.SK.i18n || {};
        window.SK.showConfirmationModal({
          type: 'success',
          title: i18n.modalRequestTitle || 'Request submitted successfully',
          message: i18n.modalContactLater || 'We will contact you later!',
          ctaText: i18n.modalBackToHome || 'Back to Home',
          ctaUrl: '/'
        });
      } else {
        bodyEl.hidden    = true;
        successEl.hidden = false;
        successEl.focus();
      }
    } else {
      const message = data?.description || data?.message || errorFallback;
      submitBtn.disabled = false;

      if (window.SK?.showConfirmationModal) {
        const i18n = window.SK.i18n || {};
        window.SK.showConfirmationModal({ type: 'error', title: i18n.modalErrorTitle || 'Something went wrong', message, ctaText: i18n.modalClose || 'Close' });
      } else {
        errorsEl.querySelector('p').textContent = message;
        errorsEl.hidden = false;
      }
    }
  } catch (err) {
    console.error('[sk-contact-form]', err);
    submitBtn.disabled = false;

    if (window.SK?.showConfirmationModal) {
      const i18n = window.SK.i18n || {};
      window.SK.showConfirmationModal({ type: 'error', title: i18n.modalErrorTitle || 'Something went wrong', message: errorFallback, ctaText: i18n.modalClose || 'Close' });
    } else {
      errorsEl.querySelector('p').textContent = errorFallback;
      errorsEl.hidden = false;
    }
  } finally {
    delete form.dataset.skAjaxSubmitting;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSKContactForms);
} else {
  initSKContactForms();
}
